import React,{useContext,useState} from 'react'
import Footer from './Footer'
import Navbar from './Navbar'
import './TenderPage.css'
// import marco from '../images/marco.png'
import {  GoArrowRight } from 'react-icons/go';
import { LoginContext } from "../Contexts/ContextProvider";
import { getRfqFile, getSpecificRfq, sendInRfqFile, submitRfqFile } from '../service/api';
import Snackbar from "@material-ui/core/Snackbar";
import MuiAlert from "@material-ui/lab/Alert";
import Popup from './Popup'
import { useRef } from 'react'

const TenderPage = () => {
    const {setRfqItem,rfqItem,userid}=useContext(LoginContext);
    const [openSnackBar,setOpenSnackBar]=useState(false);
    const [severity,setSeverity]=useState("");
    const [msg,setMsg]=useState("");
    const [rfqFile,setRfqFile]=useState([]);
    const [isOpenModifyBid,setIsOpenModifyBid]=useState(false);
    const [openEditBid,setOpenEditBid]=useState(false);
    const [bidElement,setBidElement]=useState({});
    const [indexOfBid,setIndexOfBid]=useState();
    const excelRef=useRef();
    const [excelFile,setExcelFile]=useState();

    function Alert(props) {
        return <MuiAlert elevation={6} variant="filled" {...props} />;
      }
      const handleClose = (event, reason) => {
        if (reason === 'clickaway') {
          return;
        }

        setOpenSnackBar(false);
      };

    async function modifyBid(){
        await getSpecificRfq({rfqId:rfqItem.rfqId}).then((response)=>{
            console.log(response.data);
            setRfqFile(response.data.fileAoO);
        }).catch((e)=>{
            setOpenSnackBar(true);
            setSeverity("error");
            setMsg("Error:",e);
         });
    }

    async function submitRfqHandler(){
        await submitRfqFile({rfqId:rfqItem.rfqId,fileAoO:rfqFile}).then((response)=>{
            console.log(response);
        }).catch((error) => {
            setOpenSnackBar(true);
            setSeverity("error");
            setMsg(error.message);   
          });
    }

    async function downloadTheRfq(){
        await getRfqFile({rfqId:rfqItem.rfqId}).then((response)=>{
            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', 'exportRFQ.xlsx');
            document.body.appendChild(link);
            link.click();
         }).catch((e)=>{
            setOpenSnackBar(true);
            setSeverity("error");
            setMsg("Error:",e);
         });
    }

    async function handleSubmit(e) {
    e.preventDefault();
    try {
        const fileData=new FormData();
        const data=rfqItem.rfqId;
        fileData.append('file',excelFile);
        fileData.append('rfqId',data);
        fileData.append('userId',userid);
        console.log(fileData);
        setOpenSnackBar(true);
        setSeverity("success");
        setMsg("Saved Successfully");
        await sendInRfqFile(fileData).then((response)=>{
                    if(response.data){
                        console.log("Success");
                        console.log(response);
                    }
                    else{
                        setOpenSnackBar(true);
                        setSeverity("error");
                        setMsg("Bad Request for fileData");
                    }
                 }).catch((e)=>{
                    setOpenSnackBar(true);
                    setSeverity("error");
                    setMsg("Error:",e);
                })     
    }catch(error){
        setOpenSnackBar(true);
        setSeverity("error");
        setMsg(error.message);
        return;
    }
    var frm=document.getElementsByClassName("ExcelFileForm")[0];
    console.log(frm);
    frm.reset();
}

    function handleUploadFile(e){
            e.preventDefault();
            const file=e.target[0].files[0];
            console.log(file);   
            var fileInput = 
            document.getElementById('file-rfq-update');
            var filePath = fileInput.value;
             var allowedExtensions = 
             /(\.xlsx)$/i;
   
     if (!allowedExtensions.exec(filePath)) {
         alert('No file found or Invalid File Format (.xlsx only allowed)');
   
     }
       else
       {
            if(!file) return;

             setExcelFile(file); 
             console.log(file);   
       }

        
    }


    const addARowOfRfq=(rfq)=>{
        const arr=Object.keys(rfq[0]);
        const obj = {};
        arr.forEach(element => {
          obj[element] ="";
        });
        console.log(obj);
        console.log(rfqFile);
        setRfqFile([...rfqFile,obj]);
        setOpenEditBid(true);
    }

    const handleEditBid=(indexOfBid,event)=>{
        console.log(event.target.name);
        console.log(event.target.value);
        let data = [...rfqFile];
        data[indexOfBid][event.target.name] = event.target.value;
        setRfqFile(data);
    }  
  return (
    <>
    <Navbar></Navbar>
    <div className='RFQDescription'>
        <div className='BodyOfRfqDes'>
            <div className='LeftRfqdes' >
                <div className='LeftUpperRfqDes'>
                    <img src={rfqItem.imgsrc} alt="Logo" width={140} height={80}/>
                    <div>
                        <h3 style={{width:'max-content'}}><strong>{rfqItem.Title}</strong></h3>
                        <button className='ModifyBid' onClick={(e)=>{/*modifyBid();
                        setIsOpenModifyBid(true);e.preventDefault();*/ setOpenSnackBar(true);
                        setSeverity("info");
                        setMsg("Inactive button");}}><strong>Bid Closed</strong></button>
                        <Popup trigger={isOpenModifyBid} setTrigger={setIsOpenModifyBid}>
                            {rfqFile.length!==0?
                            <table>
                                <tr className='borderTable'>
                                {console.log(Object.keys(rfqFile[0]))}
                                {console.log(rfqFile)}
                                {Object.keys(rfqFile[0]).map((item)=>(
                                    <th className='borderTable'>{item}</th>
                                ))}
                             </tr>
                                    {
                                        rfqFile.map((element,index)=>(
                                            <tr className='borderTable'>
                                            {Object.values(element).map((e)=>{
                                                return(
                                                <td className='borderTable'>{e}</td>
                                                )
                                            })}
                                            <td style={{cursor:'pointer'}} onClick={(e)=>{setOpenEditBid(true);setBidElement(element);setIndexOfBid(index)}}>edit</td>
                                            <Popup trigger={openEditBid} setTrigger={setOpenEditBid}>
                                                <h3><strong>Edit The Bid</strong></h3>
                                                {bidElement.length!==0?Object.keys(bidElement).map((e)=>{
                                                    return(
                                                        <div style={{display:'flex',margin:'2rem'}}>
                                                            <div>
                                                            <p style={{marginBottom:'0rem',padding:'1rem'}}>{e}:</p>
                                                            </div>
                                                            <input className='inputTheBidChanges' type="text" name={e} value={bidElement[e]} onChange={event => handleEditBid(indexOfBid, event)} />
                                                        </div>
                                                    )
                                                })
                                            :
                                            <p></p>}
                                            </Popup>
                                        </tr>
                                        ))
                                    }
                            </table>
                            :
                            <table className='RfqFileTable'>
                                <tr>
                                    <th contenteditable="true">A</th>
                                    <th contenteditable="true">B</th>
                                    <th contenteditable="true">C</th>
                                    <th contenteditable="true">D</th>
                                    <th contenteditable="true">E</th>
                                </tr>
                            </table>
}
                            <div className='AllignButtonRow'>
                            <button className='AddARow' onClick={()=>{addARowOfRfq(rfqFile)}}>+ Add a Row</button>
                            <button className='SubmitAllign' onClick={(e)=>{submitRfqHandler()}}>Submit</button>
                            </div>
                        </Popup>
                    </div>
                    <p className='LeftDays'>2 days left</p>
                </div>
                <p><strong style={{color:'#6B6B6B'}}>Deadline :</strong>{rfqItem.CloseDate}</p>
                <p><strong style={{color:'#6B6B6B'}}>{rfqItem.Place}</strong></p>
            </div>
<div className='RightRfqdes'>
        <div className="metricsStyle" style={{height:'20px',position:'relative',width:'320px'}}>
            <div>
                <p style={{position:'absolute',color:'#FF5050',top:'-35px',fontSize: 'small'}}>Low Chances</p>
            </div>
            <div>
                <div className="arrow-down" style={{position:'absolute'}}></div>
            </div>
            <div style={{background: '#FF5050'}}></div>
            <div style={{background: '#E3D342'}}></div>
            <div style={{background:'#7CBD48'}}></div>
            <div>
                <p style={{position:'absolute',color:'#7CBD48',top:'-35px',left:'208px',fontSize: 'small'}}>Very High Chances</p>
            </div>
        </div>
        <p>Shortlisting Chances:<strong>Moderate</strong></p>
        <p style={{color:'#218AC6',textDecorationLine: 'underline',cursor:'pointer'}}>More Details</p>
    </div>
</div>
<div className='DetailArea'>{rfqItem.Description}</div>
<button className='ViewDetailsArea'>View Details</button>
<div className='ButtonArea'>
    <div style={{display:'flex',paddingTop:'20px',textAlign:'center'}}>
    <div style={{marginLeft:'auto',marginRight:'auto'}}>
        <p><strong>Download RFQ File:</strong></p>
    <button className='DownloadTenderButton' onClick={(e)=>{/*downloadTheRfq();
        e.preventDefault();*/ setOpenSnackBar(true);
        setSeverity("info");
        setMsg("Inactive button");}}>Download</button>
    </div>
    <GoArrowRight className='arrowRfq'/>
    <div style={{marginLeft:'auto',marginRight:'auto'}}>
        <p><strong>Upload File:</strong></p>
        <form className='ExcelFileForm' onSubmit={handleUploadFile} >
            <input type="file" ref={excelRef} className='chooseExcelFile' id='file-rfq-update' />
            <button /*type='submit'*/ onClick={(e)=>{setOpenSnackBar(true);
            setSeverity("info");
            setMsg("Inactive button");}} className='UploadButtonRfq'>Upload</button>
        </form>
    </div>
    <GoArrowRight className='arrowRfq'/>
    <div style={{marginLeft:'auto',marginRight:'auto'}}>
        <p><strong>Submit Your Quote:</strong></p>
    <button className='SubmitTenderButton' onClick={(e)=>/*handleSubmit(e)*/{setOpenSnackBar(true);
        setSeverity("info");
        setMsg("Inactive button");}}>Submit</button>
    </div>
</div>
<div style={{display:'flex',justifyContent:'center',alignItems:'center'}}> 
        </div>
        </div>
    </div>
    <Footer/>
        <Snackbar
            anchorOrigin={{ vertical:'bottom', horizontal:'left' }}
            open={openSnackBar}
            autoHideDuration={8000}
            onClose={handleClose}
            >
            <Alert onClose={handleClose} severity={severity}>
                {msg}
            </Alert>
          </Snackbar>
    </>
  )
}

export default TenderPage